var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDoneOutlined = function SvgDoneOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3440",
    fillRule: "evenodd",
    d: "M19.91 12c0-4.36-3.55-7.91-7.91-7.91S4.09 7.64 4.09 12s3.55 7.91 7.91 7.91 7.91-3.55 7.91-7.91M2.29 12c0-5.36 4.35-9.71 9.71-9.71s9.71 4.35 9.71 9.71-4.35 9.71-9.71 9.71S2.29 17.36 2.29 12m13.906-2.095a.8.8 0 0 0-1.132-1.13l-4.815 4.823-1.763-1.764a.8.8 0 1 0-1.132 1.132l2.33 2.33a.8.8 0 0 0 1.132 0z",
    clipRule: "evenodd"
  })));
};
export default SvgDoneOutlined;